/* eslint-disable @typescript-eslint/no-empty-function */
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row } from 'reactstrap';
import usePageTitle from '../../common/hooks/usePageTitle';
import { ITable } from '../../components/Common/iComponents/iTable/ITable';
import { IPopUp } from '../../components/Common/iComponents/iPopUp/IpopUp';
import Filters from '../../components/Common/Filters/filters';
import PageTitle from '../../components/Common/MetaTagsHelper/metaTagsHelper';
import { getDynamicAttrUpdated, getDynamicFilterCF, transformCFColumnsData } from '../../helpers/tools_helper';
import { cancelFetchQT } from '../../store/quotationsList/saga';
import { getNameClient } from '../../helpers/nameClient';
import IForm from '../salesOrderList/iForm';
import Iloading from '../../components/Common/iComponents/iLoading/Iloading';
import { getQuotationsList, getMilestoneConfigQT } from '../../store/quotationsList/actions';

const Quotes = (props: any) => {
    const [popUpState, setpopUpState] = useState(false);
    const [updateState, setUpdateState] = useState(false);
    const [selectedRow, setSelectedRow] = useState({});
    const [title, setTitle] = useState('');

    const [pagination, setPagination] = useState<any>({
        sizePerPage: 50,
        page: 1,
    });

    const PageTitleQT = usePageTitle(props.location.pathname);

    const groupName = 'quotationsDataViewList';

    const { quotationsListData, isLoading, milestoneConfig, CountItems } = useSelector(
        (state: any) => state.quotationsList
    );

    const currentDate = new Date();

    const [form, setForm] = useState({
        from: moment(currentDate).format('YYYY-MM-DD'),
        to: moment(currentDate).format('YYYY-MM-DD'),
        order: "{'createdAt' : 'DESC'}",
        dynamicFilter: '',
        dynamicFilterCF: '',
    });

    const [QuotesList, setQuotesList] = useState<any[]>([]);
    const [tableConfig, setTableConfig] = useState([]);
    const [isFirstRun, setIsFirstRun] = useState(true);

    const dispatch = useDispatch();

    const processList = (list: any[], selectedRow: any) => {
        const t: any[] = [];
        for (const item in selectedRow) {
            list.map(function (data: { dataField: string }) {
                if (data.dataField === item)
                    t.push({
                        ...data,
                        value: selectedRow[item],
                    });
                return data;
            });
        }
        return t;
    };

    useEffect(() => {
        dispatch(getMilestoneConfigQT());
    }, []);

    useEffect(() => {
        if (isFirstRun) {
            const filters = JSON.parse(localStorage.getItem('filterOperation') || '{}');
            if (filters[groupName]) {
                handleActionOnSearch(filters[groupName]);
            }
            setIsFirstRun(false);
        } else {
            dispatch(getQuotationsList({ form, pagination }));
        }
    }, [dispatch, form, pagination, isFirstRun]);

    useEffect(() => {
        let listFinal: any[] = [];
        listFinal = transformCFColumnsData(quotationsListData);
        setQuotesList(listFinal);
    }, [quotationsListData]);

    useEffect(() => {
        const dataSorted = milestoneConfig.sort(function (a: any, b: any) {
            const x = a.order;
            const y = b.order;
            if (x > y) return 1;
            if (x < y) return -1;
            return 0;
        });
        dataSorted.forEach((milestone: any) => {
            milestone.hidden = !milestone.visibleInTable;
        });
        setTableConfig(dataSorted);
    }, [milestoneConfig]);

    const handleActionOnSearch = (data: any) => {
        const filterString = getDynamicAttrUpdated(data);
        const getFilterCF = getDynamicFilterCF(data);
        const newPagination = { ...pagination, page: 1 };
        setPagination(newPagination);
        const newForm = {
            ...data,
            order: form.order,
            dynamicFilter: filterString,
            dynamicFilterCF: getFilterCF,
        };
        setForm(newForm);
    };

    const handleActionOnRowClick = (row: any) => {
        const visibleInModalFooter = milestoneConfig.filter(
            (x: { visibleInModalFooter: boolean }) => x.visibleInModalFooter === true
        );
        let titleArr = processList(visibleInModalFooter, row);
        titleArr = titleArr.map((x) => x.value);
        setTitle(titleArr.join(' - '));
        setSelectedRow(row);
    };

    const handlePaginationChange = (newState: any) => {
        setPagination(newState);
    };

    const handleTableSort = (type: any, { sortField, sortOrder }: any) => {
        setForm({
            ...form,
            order: `{'${sortField ?? 'createdAt'}' : '${sortOrder.toUpperCase()}'}`,
        });
    };

    const onPopUpState = () => {
        setpopUpState(!popUpState);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <PageTitle>
                    <title>
                        {PageTitleQT.replace(/-/g, ' ')} | {getNameClient()}
                    </title>
                </PageTitle>
                <Container fluid>
                    <Row>
                        <Filters
                            onSearchClicked={handleActionOnSearch}
                            filterItems={milestoneConfig}
                            groupName={groupName}
                        />
                    </Row>
                    <Row>
                        <div className="container-sm">
                            <Iloading cancelFetch={cancelFetchQT} loading={isLoading} />
                        </div>
                        {QuotesList.length > 0 ? (
                            milestoneConfig.length === 0 ? (
                                <div>No config operations for this table</div>
                            ) : (
                                <ITable
                                    remote={true}
                                    CountItems={CountItems}
                                    handlerPaginationState={handlePaginationChange}
                                    data={QuotesList}
                                    fields={milestoneConfig}
                                    tableColumns={milestoneConfig}
                                    headerColorT={'bg-primary text-white'}
                                    groupName={groupName}
                                    handlePopUpState={onPopUpState}
                                    actionOnRowClick={handleActionOnRowClick}
                                    handleTableSort={handleTableSort}
                                />
                            )
                        ) : (
                            <div style={{ height: 180 }} />
                        )}
                    </Row>
                </Container>
            </div>

            <IPopUp
                stateAdd={popUpState}
                switchStateAdd={setpopUpState}
                stateUpdate={updateState}
                switchStateUpdate={setUpdateState}
                modalTitleAdd={title}
                modaleTitleUpdate={'Quotations'}
                icon="file-text"
                colorHeaderPop={'#101340'}
                width="93%"
                height="93%"
            >
                <IForm
                    selectedRow={selectedRow}
                    milestoneConfig={tableConfig}
                    groupName={groupName}
                    columsPop={5}
                />
            </IPopUp>
        </React.Fragment>
    );
};

export default Quotes;
